import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_MD } from "@/core/media";
import { formatLocation } from "@/data/locations";
import { Flex } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { BrandedLogo, LazyLoadedLogo, LogoPlaceholder } from "@/views/components/Logo";

import { ContactSection } from "./ContactSection";

interface Props extends IConsultantProfileSectionProps {
  isManager?: boolean;
}

export const ConnectionContactSection: FC<Props> = memo(({ record, isManager = false, ...rest }) => {
  const company = record.sharedProfile && record.sharedProfile.company;

  const { t } = useTranslation("session");
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);
  if (!company) {
    return null;
  }

  return (
    <Flex grow={1} direction={isMediumScreen ? "column" : "row"} innerMargin="md">
      {!!record.sharedProfile && !isManager && (
        <Flex width={isMediumScreen ? 12 : 6}>
          <Flex grow={1} direction="column" innerMargin="sm" testName={"connection" + company ? `[${company.id}]` : ""}>
            <Header size="sm" color="black" weight="bold">
              {t("CONSULTANT_PROFILES.DETAIL.CONNECTION.SECTION_HEADER")}
            </Header>
            <Flex align="flex-start" innerMargin="md">
              <LazyLoadedLogo logo={company.logo}>
                {publicUrl => <BrandedLogo src={publicUrl} size="xl" placeholder={<LogoPlaceholder />} />}
              </LazyLoadedLogo>

              <div>
                <Flex innerMargin="sm" align="center" margin={[false, false, "xs", false]}>
                  <Icon color="grey2" icon="company" size="md" />
                  <Text size="md" text={company.name} />
                </Flex>
                <Flex innerMargin="md">
                  <div>
                    <Flex innerMargin="sm">
                      <Icon color="grey2" icon="pin" size="md" />
                      <Text size="md" text={formatLocation(company.location)} />
                    </Flex>
                  </div>
                </Flex>
              </div>
            </Flex>
          </Flex>
        </Flex>
      )}
      <Flex width={isMediumScreen ? 12 : 6}>
        <ContactSection record={record} {...rest} />
      </Flex>
    </Flex>
  );
});
